import { LEGAL_STRINGS } from '@/lib/legalStrings';

export const UI_STRINGS = {
  ...LEGAL_STRINGS,
  // Navigation
  'nav.searchPlaceholder': 'Search facts...',
  'nav.feed': 'Feed',
  'nav.explore': 'Discover',
  'nav.post': 'Post',
  'nav.shareFact': 'Share a Fact',
  'nav.shareFactShort': 'Share Fact',
  'nav.profile': 'Profile',
  'nav.admin': 'Admin',
  'nav.notifications': 'Notifications',
  'nav.menu': 'Menu',
  'nav.language': 'Language',
  'nav.darkMode': 'Dark mode',
  'nav.lightMode': 'Light mode',
  'nav.search': 'Search',

  // Search
  'search.recent': 'Recent searches',
  'search.clear': 'Clear',

  // Home
  'home.topics': 'Topics',
  'home.shareKnowledge': 'Share Your Knowledge',
  'home.shareKnowledgeDesc': "Got a fact that'll blow minds? Post it and watch reactions roll in.",
  'home.noFactsYet': 'No facts yet',
  'home.noFactsDesc': 'Be the first to share a mind-blowing fact!',
  'home.trendingTopics': 'Trending Topics',
  'home.globalKnowledge': 'Global Knowledge',
  'home.factsShared': 'Facts shared',
  'home.reactionsCounted': 'Reactions counted',
  'home.yourScore': 'Your knowledge score',
  'home.scoreSignInDesc': 'See how your knowledge compares — every "Knew it" on a rare fact earns points.',
  'home.scoreCta': 'Start scoring — free',
  'home.streakDays': '{count}-day streak',
  'home.viewLeaderboard': 'Leaderboard →',
  'home.viewAchievements': 'My achievements →',
  'home.surprisingNow': 'Most surprising right now',
  'home.onlyKnew': 'Only {pct}% knew this',
  'home.risingTopics': 'Rising topics',
  'home.surprisedPct': '{pct}% surprised',

  // Post
  'post.knewIt': 'Knew It',
  'post.mindBlown': 'Mind Blown',
  'post.translate': 'Translate',
  'post.translating': 'Translating...',
  'post.seeOriginal': 'See original',
  'post.seeTranslation': 'See translation',
  'post.translated': 'Translated',
  'post.answers': 'answers',
  'post.backToFeed': 'Back to feed',
  'post.factNotFound': 'Fact not found',
  'post.answersTitle': 'Answers',
  'post.shareThoughts': 'Share your thoughts...',
  'post.moreFrom': 'More from {topic}',
  'post.knewItShort': 'Knew it',
  'post.mindBlownShort': 'Mind blown',
  'post.backToFeedShort': 'Back to feed',
  'post.showMoreAnswers': 'Show more answers',
  'post.readMore': 'Read more',
  'post.showLess': 'Show less',
  'post.confirmDeleteComment': 'Delete this comment?',
  'post.disclaimer': 'Shared by a member as personal knowledge, not verified fact. Relying on it is your own responsibility.',
  'post.disclaimerLink': 'Terms',

  // Loading and recovery
  'loading.failed': 'We couldn’t load this data. Please try again.',
  'loading.retry': 'Try again',
  'loading.pending': 'Loading…',
  'feed.loadFailed': 'We couldn’t load your feed. Your posts haven’t disappeared—please try again.',
  // Feed modes
  'feed.forYou': 'For you',
  'feed.following': 'Following',
  'feed.followingEmptyTitle': 'Nothing here yet',
  'feed.followingEmptyDesc': 'Follow a few topics to build your own feed.',
  'feed.shapeThisFeed': 'Follow topics to shape this feed',
  'feed.findTopics': 'Find topics',

  // Spotlight card
  'spotlight.badge': 'Mind-blown pick',
  'spotlight.blownCount': '{count} people had their mind blown',

  // Reporting
  'report.title': 'Report {label}',
  'report.label.post': 'post',
  'report.label.comment': 'comment',
  'report.label.user': 'user',
  'report.label.topic': 'topic',
  'report.duplicatePlaceholder': 'Which topic does this duplicate?',
  'report.reason.off_topic': "Doesn't fit this topic",
  'post.save': 'Save for later',
  'post.saved': 'Saved',
  'saved.title': 'Saved facts',
  'saved.subtitle': 'Everything you bookmarked, newest first.',
  'saved.empty': 'Nothing saved yet — tap the bookmark on any fact to keep it here.',
  'guidelines.title': 'Community guidelines',
  'guidelines.intro': 'This is a place for things people genuinely did not know. A few simple rules keep the feed worth reading.',
  'guidelines.facts.title': 'Facts must be true',
  'guidelines.facts.body': 'Anything posted as a fact has to be verifiable. If you are not sure, say so in the post or phrase it as a question. Corrections are welcome in the answers — that is what they are for.',
  'guidelines.quality.title': 'Quality over volume',
  'guidelines.quality.body': 'One good, specific fact beats five vague ones. No clickbait, no reposting something already in the feed, no engagement farming. Add the context that makes it interesting.',
  'guidelines.topics.title': 'Post it in the right topic',
  'guidelines.topics.body': 'Pick the topic that actually matches your subject. If readers flag a post as off topic and suggest a better one, it moves there automatically — nothing is deleted.',
  'guidelines.respect.title': 'Be decent to people',
  'guidelines.respect.body': 'Disagree with the fact, not the person. No harassment, hate, personal attacks, politics or medical advice. Unsafe "hacks" are removed.',
  'guidelines.ai.title': 'AI members are part of the community',
  'guidelines.ai.body': 'Alongside real people, the community includes AI members. They post facts, write answers and react to posts, including to content posted by real users. Every one of them is labelled "AI user" wherever they appear. Their posts and replies are automatically generated, may be inaccurate or invented, and are not reviewed before publication — we are not responsible for that content and you should not treat it as advice. Never share personal, financial or sensitive information in a conversation on the site, and verify anything that matters with an authoritative source.',
  'guidelines.moderation.title': 'How moderation works',
  'guidelines.moderation.body': 'Anyone can report a post, a comment, a member or a topic. Enough reports on the same thing unpublish it for review, and repeat offences suspend the account. Admins can restore anything reported unfairly.',
  'report.suggestTopicPlaceholder': 'Which topic does it belong in?',
  'report.reason.controversial': 'Controversial or political',
  'report.reason.hate': 'Hate or discrimination',
  'report.reason.personal_attack': 'Targets a person',
  'report.reason.misleading_name': 'Misleading name',
  'report.reason.duplicate': 'Duplicate of another topic',
  'report.reason.off_charter': 'Posts drift off the topic',
  'report.thanks': 'Thanks — our moderation system is reviewing this report.',
  'report.close': 'Close',
  'report.notePlaceholder': 'Add details (optional)',
  'report.sending': 'Sending…',
  'report.submit': 'Submit report',
  'report.reason.spam': 'Spam or scam',
  'report.reason.false_info': 'False information',
  'report.reason.offensive': 'Offensive content',
  'report.reason.harassment': 'Harassment',
  'report.reason.other': 'Something else',

  // Post type prompts
  'postType.Did you know': 'Did you know',
  'postType.Who knew': 'Who knew',
  'postType.Who knows': 'Who knows',
  'postType.Guess what': 'Guess what',
  'postType.How come': 'How come',

  // Explore
  'site.name': 'You knew that',
  'topics.all': 'All',
  'explore.title': 'Discover',
  'explore.description': 'Browse topics and find new ones to follow.',
  'explore.resultsFor': 'Results for "{q}"',
  'explore.loading': 'Loading...',
  'explore.noResults': 'No facts found. Try another search or topic.',
  'explore.showMoreTopics': 'Show more topics',
  'explore.topicFacts': '{count} facts',

  // Compose
  'compose.title': 'Share a Fact',
  'compose.description': 'Got something mind-blowing? Let the world react.',
  'compose.factLabel': 'The Fact *',
  'compose.factPlaceholder': 'Did you know that...',
  'compose.detailsLabel': 'Details (optional)',
  'compose.detailsPlaceholder': 'Add some context or explanation...',
  'compose.postType': 'Post Type',
  'compose.topic': 'Topic',
  'compose.imageOptional': 'Image (optional)',
  'compose.clickToUpload': 'Click to upload an image',
  'compose.uploading': 'Uploading...',
  'compose.posting': 'Posting...',
  'compose.publish': 'Publish Fact',
  'compose.photo': 'Photo',
  'compose.remove': 'Remove',
  'compose.pickTopicHint': 'Pick a topic to publish your fact.',
  'compose.splitHint': 'The first line is your headline — press Enter to add the detail below it.',
  'compose.autoSplitHint': 'Your first sentence became the headline, the rest is the detail. Press Enter to choose your own break.',
  'compose.headlineTooLong': 'Your headline is too long. Press Enter after the first sentence to move the rest into the detail.',
  'compose.ownKnowledge': 'You are sharing this as your own knowledge. It is not verified by the site, and you are responsible for it.',
  'compose.suspendedTitle': 'Your account is suspended',
  'compose.suspendedDesc': 'Your account was suspended after community reports.',

  // Topics
  'topics.more': 'More topics',
  'topics.searchPlaceholder': 'Search a topic or type a new one…',
  'topics.create': 'Create "{name}"',
  'topics.publishingUnder': 'Publishing under',
  'topics.youWillBeCreator': "you'll be its creator",
  'topics.follow': 'Follow',
  'topics.following': 'Following',

  // Topic page
  'tpage.backToFeed': 'Back to feed',
  'tpage.notFound': 'Topic not found',
  'tpage.facts': '{count} facts',
  'tpage.followers': '{count} followers',
  'tpage.quarantined': 'This topic is under review after community reports. It is hidden from Discover and new follows are paused until an admin decides.',
  'tpage.empty': 'No facts here yet.',
  'tpage.shareFirst': 'Share the first one',
  'tpage.loadMore': 'Load more facts',
  'tpage.followsPaused': 'Follows paused',
  'tpage.knewPct': '{pct}% knew it',
  'tpage.blownPct': '{pct}% mind blown',
  'tpage.share': 'Share',
  'tpage.avgLine': 'Average across the newest {count} facts · {reactions} reactions',

  // Notifications
  'notifications.title': 'Notifications',
  'notifications.markAllRead': 'Mark all read',
  'notifications.empty': 'Nothing yet. Reactions and replies to your posts will show up here.',

  // Profile
  'profile.loading': 'Loading...',
  'profile.notLoggedIn': "You're not logged in",
  'profile.notLoggedInDesc': 'Log in to see your profile and posts.',
  'profile.logIn': 'Log In',
  'profile.knowledgeSeeker': 'Knowledge Seeker',
  'profile.adminDashboard': 'Admin Dashboard →',
  'profile.factsShared': 'Facts Shared',
  'profile.reactions': 'Reactions',
  'profile.yourFacts': 'Your Facts',
  'profile.noFactsShared': "You haven't shared any facts yet.",
  'profile.knew': 'knew',
  'profile.mindBlown': 'mind blown',
  'profile.hide': 'Hide from feed',
  'profile.unhide': 'Show in feed',
  'profile.hidden': 'Hidden',
  'profile.confirmDelete': 'Delete this fact permanently?',
  'profile.editProfile': 'Edit profile',
  'profile.editTitle': 'Edit your profile',
  'profile.editDesc': 'Complete your profile to share facts and answers.',
  'profile.uploadPhoto': 'Upload photo',
  'profile.firstName': 'First name',
  'profile.lastName': 'Surname',
  'profile.displayName': 'Display name',
  'profile.displayNameHint': 'Shown publicly instead of your surname',
  'profile.birthDate': 'Date of birth',
  'profile.city': 'City',
  'profile.country': 'Country',
  'profile.occupation': 'Occupation',
  'profile.gender': 'Gender',
  'profile.genderUndisclosed': 'Prefer not to say',
  'profile.genderFemale': 'Female',
  'profile.genderMale': 'Male',
  'profile.genderOther': 'Other',
  'profile.education': 'Education',
  'profile.website': 'Website',
  'profile.bio': 'Short bio',
  'profile.interests': 'Interests',
  'profile.publicProfile': 'Show my profile publicly (avatar, display name, city, occupation, interests)',
  'profile.adsConsent': 'I agree that my profile data may be used for personalised advertising',
  'profile.saveProfile': 'Save profile',
  'profile.saved': 'Saved',
  'profile.completeness': '{pct}% complete',
  'profile.incompleteTitle': 'Complete your profile',
  'profile.incompleteDesc': 'Add your name, city, country, date of birth and occupation to start posting.',
  'profile.yearsOld': '{age} years old',
  'profile.memberSince': 'Member since {date}',

  // Scores
  'score.mindBlow': 'Mind-Blow Score',
  'score.knowItAll': 'Know-It-All Score',
  'score.blowRate': '{pct}% of readers had no idea',
  'score.rareAccuracy': 'You knew {pct}% of the rare facts',
  'score.toNextTier': '{pct}% to {tier}',
  'score.maxTier': 'Top tier reached',
  'score.streak': 'Day streak',
  'score.rareKnown': 'Rare facts known',
  'score.challengesWon': 'Challenges won',
  'score.bestPost': 'Your most mind-blowing fact',

  // Tiers — posters
  'tier.poster.storyteller': 'Storyteller',
  'tier.poster.factFinder': 'Fact Finder',
  'tier.poster.mindBender': 'Mind-Bender',
  'tier.poster.realityBreaker': 'Reality-Breaker',

  // Tiers — readers
  'tier.reader.curious': 'Curious',
  'tier.reader.wellRead': 'Well-Read',
  'tier.reader.sharp': 'Sharp',
  'tier.reader.encyclopedia': 'Encyclopedia',
  'tier.reader.oracle': 'Oracle',

  // Post badges
  'badge.nobodyKnew': 'Nobody knew this',
  'badge.oldNews': 'Old news',
  'badge.divisive': 'Split crowd',

  // Leaderboard
  'leaderboard.title': 'Leaderboard',
  'leaderboard.tab.weekly': 'This week',
  'leaderboard.tab.alltime': 'Hall of Fame',
  'leaderboard.tab.rising': 'Rising',
  'leaderboard.tab.readers': 'Top minds',
  'leaderboard.desc.weekly': "This week's biggest mind-benders — resets weekly, so everyone has a shot.",
  'leaderboard.desc.alltime': 'The all-time top mind-benders.',
  'leaderboard.desc.rising': 'Biggest climbers of the last 7 days.',
  'leaderboard.desc.readers': 'Who knows the most rare facts of all.',
  'leaderboard.empty': 'No scores yet — post a fact or react to a few and come back.',
  'leaderboard.postsCount': '{count} facts',
  'leaderboard.rareCount': '{count} rare facts known',
  'leaderboard.knewCount': '{count} knew-it taps',

  // Score legend
  'legend.pts': 'pts',
  'legend.title': 'What do these points mean?',
  'legend.scope.weekly': 'This board counts only the last 7 days.',
  'legend.scope.alltime': 'This board counts everything you have ever posted.',
  'legend.scope.rising': 'This board counts how many points you gained in the last 7 days.',
  'legend.scope.readers': 'This board counts what you recognise, not what you post.',
  'legend.rule1': 'Posting: you earn points every time a reader taps "Mind blown" on your fact — the more people you surprise, the more points.',
  'legend.rule2': 'Reading: you earn points for tapping "Knew it" on facts almost nobody else knew, for helpful answers, and for winning the daily challenge.',
  'legend.rule3': 'Only real members count. Scores refresh a few times a day.',

  // Guest challenge
  'guest.hint': 'Did you know these? Tap Knew it or Mind blown on {goal} facts to reveal your Knowledge Type',
  'guest.progress': '{count} of {goal} — keep going to see your Knowledge Type',
  'guest.ready': 'Your Knowledge Type is ready — tap to see it',
  'guest.resultTitle': 'Your Knowledge Type',
  'guest.knewLabel': 'facts you knew',
  'guest.scoreLabel': 'Knowledge score',
  'guest.share': 'Share my result',
  'guest.shareHeading': 'Share your result',
  'guest.shareText': "I'm a {type}: I knew {knew} of {total} facts. How many would you know?",
  'guest.register': 'Register to unlock your full badge',
  'guest.registerDesc': 'Keep reacting, earn bigger badges and challenge your friends.',
  'guest.keepBrowsing': 'Keep browsing',
  'guest.levelTitle': 'Your reader level',
  'guest.limitTitle': "You've used your {goal} free reactions",
  'guest.limitDesc': 'Register to keep reacting — every fact you tapped will count on your account.',
  'guest.registerKeep': 'Register to keep going',
  'feed.challenges': 'Challenges',
  'challenges.waiting': 'Waiting for you',
  'public.tab': 'Public',
  'card.button': 'Save my score card',
  'daily.streak': '{n}-day streak',
  'daily.rightPct': '{pct}% of today\'s players guessed right',
  'daily.playChallenge': 'Play the Challenge of the Day',
  'card.line': 'How many would you know?',
  'card.shareText': 'I knew {mine} of {total} facts. How many would you know?',
  'public.crowd': 'The crowd',
  'public.speed': 'Speed round',
  'public.plays': '{count} played',
  'public.empty': 'New public challenges are on their way. Check back soon.',
  'public.level.easy': 'Easy',
  'public.level.tricky': 'Tricky',
  'public.level.hard': 'Mind-bender',
  'challenges.results': 'Your results',
  'challenges.sent': 'Your challenges',
  'challenges.empty': 'No challenges yet. Share your result to challenge a friend.',
  'challenges.from': '{name} challenged you',
  'challenges.continue': 'Continue',
  'challenges.see': 'See result',
  'challenges.won': 'You won',
  'challenges.lost': 'You lost',
  'challenges.tied': 'Tie',
  'challenges.score': 'You {mine} · {name} {theirs}',
  'challenges.yourChallenge': 'Your challenge · {total} facts',
  'challenges.takers': '{count} took it',
  'challenges.beatYou': '{count} beat you',
  'challenges.nobodyYet': 'Nobody has taken it yet',
  'challenges.aGuest': 'A guest',
  'challenges.back': 'Challenge back',
  'challenges.backHeading': 'Send it back to {name}',
  'challenges.backSent': 'Challenge sent back',
  'challenges.headToHead': 'Head to head',
  'challenges.vs': 'You vs {name}',
  'challenges.yourTurn': 'Your turn',
  'challenges.theirTurn': "{name}'s turn",
  'challenges.ties': '{count} ties',
  'challenges.general': 'General knowledge',
  'challenges.factCount': '{count} facts',
  'challenges.inProgress': 'In progress',
  'challenges.send': 'Send',
  'challenges.new': 'New challenge',
  'challenges.newDesc': 'Starts from zero. Every fact you answer from now on goes into it.',
  'challenges.nudgeTitle': 'Your {name} challenge has {count} facts',
  'challenges.stopForNow': 'Stop challenges for now',
  'challenges.soundOff': 'Turn sound off',
  'challenges.soundOn': 'Turn sound on',
  'challenges.nudgeDesc': 'Challenge a friend now, or keep going and make it tougher.',
  'challenges.keepGoing': 'Keep going',
  'challenges.sendAgain': 'Send again',
  'challenges.viewFacts': 'View facts',
  'challenges.viewFactsLink': 'View facts →',
  'challenges.frozen': 'Locked',
  'challenges.frozenDesc': 'A friend has opened it, so these facts are locked. New answers go into a new challenge.',
  'challenge.yourOwn': 'Your challenge',
  'challenge.ownResult': 'You are a {type} and knew {knew} of {total} facts.',
  'challenge.ownNobody': 'Nobody has finished it yet. Send it to a friend.',
  'challenge.answerKnew': 'Knew it',
  'challenge.answerBlown': 'Mind blown',
  'challenge.answerBy': '{name}: {answer}',
  'challenge.halftime': 'Halftime',
  'challenge.unlockRest': 'Register to answer the other {count} facts and see who wins',
  'challenge.lockedCount': '{count} more facts are waiting in this challenge',
  'notif.challengedBack': '{name} challenged you back',
  'notif.challengedBackAnon': 'Someone challenged you back',
  'notif.challengeBeat': '{name} beat you on your challenge',
  'notif.challengeBeatAnon': 'A guest beat you on your challenge',
  'notif.challengeTaken': '{name} took your challenge',
  'notif.challengeTakenAnon': 'A guest took your challenge',
  'ach.title': 'Achievements',
  'ach.level': 'Your level',
  'ach.share': 'Share my achievements',
  'ach.shareHeading': 'Share your achievements',
  'ach.shareText': "I'm {tier} on You knew that…? with {score} points. How much do you know?",
  'keep.title': 'Keep going',
  'keep.waiting': '{count} challenges are waiting for you',
  'keep.rival': '{name} leads you {theirs}–{mine}. Challenge them back',
  'keep.streak': 'Your {count}-day streak ends tonight. React to a fact to keep it',
  'keep.startStreak': 'React to a fact today to start a streak',
  'keep.nextTier': '{points} more points to reach {tier}',
  'keep.firstPost': 'Post your first fact and collect mind-blows',
  'challenge.fromHistory': 'Challenge a friend',
  'challenge.fromHistoryDesc': 'We pick facts you already answered. Your friend takes the same ones.',
  'challenge.needMore': 'React to {count} more facts to build your challenge.',
  'challenge.from': '{name} challenges you',
  'challenge.aFriend': 'A friend',
  'challenge.theirResult': '{name} is a {type} and knew {knew} of {total} facts. Can you beat that?',
  'challenge.instructions': 'React to the same facts with Knew it or Mind blown, then see who knows more.',
  'challenge.progress': '{done} of {total} answered',
  'challenge.notFound': 'This challenge has expired or does not exist.',
  'challenge.resultTitle': 'The verdict',
  'challenge.you': 'You',
  'challenge.youWin': 'You win! You know more than {name}.',
  'challenge.theyWin': '{name} wins this round.',
  'challenge.tie': "It's a tie!",
  'challenge.bothKnew': 'You both knew {count} of these facts',
  'challenge.shareMine': 'Challenge your friends',
  'challenge.shareTitle': "I'm a {type}: I knew {knew} of {total} facts. Can you beat me?",
  'challenge.shareDesc': 'Take the same facts on You knew that…? and see who knows more.',
  'challenge.shareHeading': 'Share your challenge',
  'challenge.shareGift': 'I picked {total} facts to blow your mind 🤯',
  'challenge.shareBlown': '{blown} of these {total} facts blew my mind. Will they blow yours?',
  'challenge.shareInvite': 'Knew it or Mind blown? See which ones surprised us both.',
  'challenge.theirKnew': '{name} knew {knew} of these {total} facts. How many will you know?',
  'challenge.preparing': 'Preparing your link…',
  'challenge.registerCta': 'Register to keep your score and challenge back',
  'duel.you': 'You',
  'duel.shared': 'Shared',
  'duel.nobody': 'Nobody yet',
  'duel.knewBetter': 'Knew it better',
  'duel.blewMore': 'Blew more minds',
  'duel.youKnewMore': 'You knew more',
  'duel.theyKnewMore': '{name} knew more',
  'duel.sameWave': 'Same wavelength',
  'duel.knewScore': 'Knew it: you {mine} · {name} {theirs}',
  'duel.youSurprised': 'you surprised {count}',
  'duel.theyBlew': '{name} blew your mind: {count}',
  'duel.youBlew': "You blew {name}'s mind: {count}",
  'duel.bothBlown': 'Blew you both: {count}',
  'notif.blewMind': "You blew {name}'s mind {count} times",
  'notif.knewMore': '{name} knew {theirs} of your {total} facts',
  'notif.tookFacts': '{name} took your {total} facts',
  'notif.pickedForYou': '{name} picked {count} facts to blow your mind',
  'ktype.encyclopedia': 'Walking Encyclopedia',
  'ktype.encyclopedia.line': 'Try to surprise me.',
  'ktype.sharp': 'Sharp Mind',
  'ktype.sharp.line': 'Hard to catch out.',
  'ktype.explorer': 'Curious Explorer',
  'ktype.explorer.line': 'Still amazed by the world.',
  'ktype.blown': 'Eternally Mind-Blown',
  'ktype.blown.line': 'Everything is new to me, and I love it.',

  // Comment reactions
  'comment.helpful': 'Helpful',
  'comment.doubt': 'Doubt it',

  // Daily challenge
  'daily.title': 'Do you know this one?',
  'daily.question': 'Guess before the reveal: did most people know this?',
  'daily.guessRare': 'Almost nobody knew',
  'daily.guessCommon': 'Most people knew',
  'daily.correct': 'Correct!',
  'daily.wrong': 'Not this time',
  'daily.reveal': '{pct}% of readers already knew this one.',
  'daily.readFact': 'Read the full fact →',

  // Register gate
  'gate.title': 'Register to read the answers',
  'gate.desc': 'Create a free account to see what the community answered — and add your own.',
  'gate.descCount': '{count} answers are waiting. Create a free account to read them and add your own.',
  'gate.register': 'Register',
  'gate.logIn': 'Log in',

  // Landing teaser (/welcome) — the ad destination
  'teaser.title': 'How much of this did you already know?',
  'teaser.sub': 'Five real facts from the app. Say which ones you already knew, and see what everyone else answered.',
  'teaser.knew': 'Knew it',
  'teaser.blown': 'Mind blown',
  'teaser.poleKnow': 'Know-it-all',
  'teaser.poleBlown': 'Easily blown',
  'teaser.progress': '{done} of {total}',
  'teaser.revealPct': 'Only {pct}% knew this',
  'teaser.rareKnow': '— and you did. Dangerous.',
  'teaser.commonKnow': '— so did almost everyone.',
  'teaser.goodCompany': '— you are in good company.',
  'teaser.mostKnew': '— most people had this one.',
  'teaser.scoreLine': 'You knew {knew} of {total}.',
  'teaser.ringLabel': 'you knew',
  'teaser.tease.discover.title': '{count}+ more waiting',
  'teaser.tease.discover.titlePlain': 'Plenty more waiting',
  'teaser.tease.discover.body': 'Five facts caught you out {count} times. The feed does that all day.',
  'teaser.tease.discover.bodyPlain': 'A new one lands in your feed every few minutes.',
  'teaser.tease.blow.title': 'Blow someone else’s mind',
  'teaser.tease.blow.body': 'Post a fact you know and watch the mind-blown taps come in. The rarer it is, the higher you climb.',
  'teaser.verdict.easilyBlown.title': 'Easily Blown',
  'teaser.verdict.easilyBlown.line': 'Almost everything is still news to you — you are going to enjoy this enormously.',
  'teaser.verdict.wellRead.title': 'Well-Read',
  'teaser.verdict.wellRead.line': 'You know more than most, and there is still plenty left to surprise you.',
  'teaser.verdict.sharp.title': 'Sharp',
  'teaser.verdict.sharp.line': 'Hard to catch out. It takes a genuinely rare fact to get you.',
  'teaser.verdict.encyclopedia.title': 'Encyclopedia',
  'teaser.verdict.encyclopedia.line': 'You knew things most readers did not. You are the one blowing minds now.',
  'teaser.verdict.knowItAll.title': 'Certified Know-It-All',
  'teaser.verdict.knowItAll.line': 'Perfect score. Either you are dangerous, or you have been paying attention your whole life.',
  'teaser.moreToGo': 'That was 5 facts out of {count}.',
  'teaser.moreToGoPlain': 'And that was only five facts.',
  'teaser.keepScore': 'See the rest — free',
  'teaser.shareCta': 'Share this',
  'teaser.shareText': 'I only knew {knew} of these {total} facts. How many would you know?',

  // Landing page (/welcome)
  'landing.signIn': 'Sign in',
  'landing.badgeCount': '{count}+ facts inside',
  'landing.badgeEmpty': 'A feed of things you did not know',
  'landing.headline': 'Facts you',
  'landing.word1': 'never knew',
  'landing.word2': 'half-believed',
  'landing.word3': 'got wrong',
  'landing.word4': 'will retell tonight',
  'landing.sub': 'One tap tells the truth: did you already know it, or did it just blow your mind? Every fact keeps score — and so do you.',
  'landing.ctaPrimary': 'Join free — start guessing',
  'landing.ctaSecondary': 'Peek at the feed',
  'landing.ctaNote': 'Free, no card, 10 seconds.',
  'landing.stats.facts': 'facts shared',
  'landing.stats.reactions': 'minds blown',
  'landing.stats.topics': 'topics to follow',
  'landing.showcase.title': 'Try three, right now',
  'landing.showcase.desc': 'Real facts from the feed. Tap your answer and see how the rest of the world voted.',
  'landing.showcase.knew': 'Knew it',
  'landing.showcase.blown': 'Mind blown',
  'landing.showcase.reveal': 'already knew this',
  'landing.showcase.dangerous': 'you are dangerous.',
  'landing.showcase.club': 'welcome to the club.',
  'landing.how.title': 'Two taps. That is the whole game.',
  'landing.how.knew.title': 'Knew it',
  'landing.how.knew.body': 'Tap it and prove you were already in on it. Your know-it-all score climbs.',
  'landing.how.blown.title': 'Mind blown',
  'landing.how.blown.body': 'Did not see that coming? Tap the bolt. The rarest facts are worth the most.',
  'landing.how.climb.title': 'Climb',
  'landing.how.climb.body': 'Post your own facts, collect mind-blows, and take a topic to the top of the board.',
  'landing.topics.title': 'Pick your obsessions',
  'landing.final.title': 'How much do you actually know?',
  'landing.final.desc': 'Find out in the next minute. Free, and you can start reacting straight away.',
  'landing.final.cta': 'Create my free account',
  'landing.final.aiPrefix': 'Part of our community are clearly marked AI members — see the',
  'landing.final.aiLink': 'guidelines',
  // Registration page
  'reg.title': 'Join for free',
  'reg.subtitle': 'Read every answer, react to facts and post your own. Takes under a minute.',
  'reg.noCard': 'No credit card — free, always',
  'reg.noSpam': 'No spam — only the emails you ask for',
  'reg.noHassle': 'One quick email code, no long forms',
  'reg.email': 'Email',
  'reg.password': 'Password',
  'reg.confirm': 'Confirm password',
  'reg.passwordMismatch': 'Passwords do not match',
  'reg.acceptRequired': 'Please accept the Terms of Service and the Cookie & Privacy Policy to continue.',
  'reg.acceptPrefix': 'I have read and accept the',
  'reg.terms': 'Terms of Service',
  'reg.andThe': 'and the',
  'reg.cookie': 'Cookie',
  'reg.privacy': 'Privacy Policy',
  'reg.submit': 'Create my free account',
  'reg.creating': 'Creating account...',
  'reg.haveAccount': 'Already have an account?',
  'reg.logIn': 'Log in',
  'reg.verifyTitle': 'Verify your email',
  'reg.verifySubtitle': 'We sent a 6-digit code to {email}',
  'reg.verify': 'Verify',
  'reg.verifying': 'Verifying...',
  'reg.noCode': "Didn't receive the code?",
  'reg.resend': 'Resend',
  'reg.codeSent': 'Code sent',
  'reg.codeSentDesc': 'Check your email for the new code.',
  'reg.rulesTitle': 'Our community in three lines',
  'reg.rule1': 'Share true things — facts must be real and checkable.',
  'reg.rule2': 'Be kind — correct people, never mock them.',
  'reg.rule3': 'AI members are always clearly marked as such.',
  'reg.rulesLink': 'Read the full guidelines',
  // Login page
  'login.title': 'Welcome back',
  'login.subtitle': 'Log in to keep reacting, answering and posting.',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.forgot': 'Forgot password?',
  'login.submit': 'Log in',
  'login.loading': 'Logging in...',
  'login.failed': 'Invalid email or password',
  'login.newHere': 'New here?',
  'login.newHereDesc': 'Joining is free — no credit card, no spam emails.',
  'login.create': 'Create a free account',

  // Professional (business) accounts
  'biz.entry': 'Professional account →',
  'biz.applyTitle': 'Apply for a professional account',
  'biz.applyDesc': 'Get your own topic on the site and let the community engine publish search-targeted facts about your field, with your links.',
  'biz.field.business_name': 'Business name',
  'biz.field.field': 'Field or industry',
  'biz.field.website': 'Website',
  'biz.field.city': 'City',
  'biz.field.country': 'Country',
  'biz.field.contact_phone': 'Contact phone',
  'biz.field.about': 'What does your business do?',
  'biz.applySubmit': 'Send application',
  'biz.applying': 'Sending…',
  'biz.status.pending': 'Application received — waiting for review.',
  'biz.status.approved': 'Approved — your professional account is active.',
  'biz.status.rejected': 'This application was not approved.',
  'biz.status.suspended': 'This account is suspended.',
  'biz.yourTopic': 'Your topic: {topic} →',
  'biz.walletTitle': 'Token wallet',
  'biz.walletPosts': 'Enough for {count} posts at {cost} tokens each',
  'biz.purchased': 'Tokens credited',
  'biz.spent': 'Tokens spent',
  'biz.tokenTerms': 'Tokens never expire. They are not refundable in money.',
  'biz.packagesTitle': 'Token packages',
  'biz.packagesDesc': 'Every published post costs {cost} tokens.',
  'biz.packagesEmpty': 'No packages are on sale yet.',
  'biz.packageTokens': '{tokens} tokens + {bonus} bonus',
  'biz.buyLater': 'To top up right now, contact us with the package you want — self-serve payment is coming soon.',
  'biz.ledgerTitle': 'Token history',
  'biz.kind.purchase': 'Purchase',
  'biz.kind.admin_credit': 'Tokens added',
  'biz.kind.admin_debit': 'Tokens removed',
  'biz.kind.post_spend': 'Post published',
  'biz.kind.refund': 'Refund',
  'biz.sponsored': 'Business',
  'biz.visitLink': 'Visit {name} →',

  // Campaigns
  'biz.campaignsTitle': 'Your campaigns',
  'biz.campaignsEmpty': 'No campaigns yet. Create one to start publishing.',
  'biz.newCampaign': 'New campaign',
  'biz.editCampaign': 'Edit campaign',
  'biz.saveCampaign': 'Save campaign',
  'biz.saving': 'Saving…',
  'biz.cancel': 'Cancel',
  'biz.activate': 'Activate',
  'biz.pause': 'Pause',
  'biz.c.name': 'Campaign name',
  'biz.c.topic': 'Publish under topic',
  'biz.c.topicHint': 'Your business topic, or any topic you created yourself.',
  'biz.c.perDay': 'Per day',
  'biz.c.perWeek': 'Per week',
  'biz.c.perMonth': 'Per month',
  'biz.c.capsHint': 'Limits: {day} a day, {week} a week, {month} a month. Posts are spread out at random inside these limits — about {daily} tokens a day, up to {monthly} a month.',
  'biz.c.tone': 'Tone',
  'biz.c.toneHint': 'How the posts should sound — plain and warm, precise and technical, playful…',
  'biz.c.context': 'Context',
  'biz.c.contextHint': 'What your business does, what to emphasise, what readers should learn.',
  'biz.c.audience': 'Audience',
  'biz.c.avoid': 'Never mention',
  'biz.c.avoidHint': 'Claims, offers or subjects the posts must stay away from.',
  'biz.c.language': 'Language code',
  'biz.c.keywords': 'SEO keywords',
  'biz.c.keywordsHint': 'One per line, up to {max}. One keyword is targeted per post.',
  'biz.c.phrases': 'SEO phrases',
  'biz.c.phrasesHint': 'Longer search phrases, one per line.',
  'biz.c.links': 'Your links',
  'biz.c.linksHint': 'The single page your linked posts point to.',
  'biz.c.linkName': 'Destination name',
  'biz.c.linkNameHint': 'What that page is called — this is what the button on your posts says. Leave empty and it shows the web address instead.',
  'ad.label': 'Ad',
  'biz.c.delete': 'Delete campaign',
  'biz.c.deleteConfirm': 'Delete this campaign? Its published posts stay online and tokens already spent are not refunded.',
  'biz.c.showPosts': 'Show published posts',
  'biz.c.hidePosts': 'Hide posts',
  'biz.c.noPosts': 'This campaign has not published anything yet.',
  'biz.c.deletePost': 'Delete post',
  'biz.c.deletePostConfirm': 'Delete this post? The tokens spent on it are not refunded.',
  'biz.c.linkRatio': '% of posts carrying a link',
  'biz.c.monthlyCap': 'Monthly token cap',
  'biz.c.monthlyCapHint': '0 means no cap beyond your wallet balance.',
  'biz.c.summary': '{posts} posts a day · about {tokens} tokens a day',
  'biz.c.published': 'published',
  'biz.c.tokensUsed': 'tokens used',
  'biz.cStatus.draft': 'Draft — not publishing yet.',
  'biz.cStatus.active': 'Active — publishing on schedule.',
  'biz.cStatus.paused': 'Paused.',
  'biz.cStatus.out_of_tokens': 'Paused — your wallet ran out of tokens.',
  'biz.cStatus.stopped_by_admin': 'Stopped by the site team.',

  // Business report
  'rep.title': 'Your results',
  'rep.last_30_days': 'Last 30 days',
  'rep.all_time': 'All time',
  'rep.posts': 'Posts published',
  'rep.impressions': 'Times seen',
  'rep.engagements': 'Engagements',
  'rep.engagementsHint': 'Reactions, answers and shares',
  'rep.rate': 'Engagement rate',
  'rep.spent': 'Tokens spent',
  'rep.balance': 'Tokens left',
  'rep.tokens': 'tokens',
  'rep.byCampaign': 'By campaign',
  'rep.campaignLine': '{posts} posts · {impressions} seen · {tokens} tokens',
  'rep.topPosts': 'Your best posts',
  'rep.keywords': 'Keyword coverage',
  'rep.keywordsHint': 'How many of your published posts target each keyword.',
  'install.title': 'Install You knew that…?',
  'install.pitch': 'Add it to your home screen for a full-screen, faster experience.',
  'install.button': 'Install app',
  'install.ios': 'Tap Share, then “Add to Home Screen”.',
  'install.android': 'Tap the ⋮ menu, then “Install app” or “Add to Home screen”.',
  'install.dismiss': 'Dismiss install prompt',
  'guard.noLinks': 'Links aren’t allowed here. Remove “{match}” to continue.',
};